import { render } from "./app-vivition.vue?vue&type=template&id=2151e135&ts=true"
import script from "./app-vivition.vue?vue&type=script&lang=ts"
export * from "./app-vivition.vue?vue&type=script&lang=ts"

import "./app-vivition.vue?vue&type=style&index=0&id=2151e135&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__